export type AlliedRegion = 'DDCA' | 'DDPA' | 'DDIC';

export const ALLIED_STATE_REGION_MAP: Record<AlliedRegion, string[]> = Object.freeze({
  DDIC: ['AL', 'FL', 'GA', 'LA', 'MT', 'NV', 'TX', 'UT'],
  DDPA: ['DC', 'DE', 'MD', 'NY', 'PA', 'WV'],
  DDCA: ['CA'],
});

export function findAlliedRegionByState(state: string): AlliedRegion | null {
  const match = Object.entries(ALLIED_STATE_REGION_MAP).find(([, states]) => states.includes(state));
  return match?.[0] as AlliedRegion | null;
}
